<template>
  <div class="memory-card-container">
    <slot></slot>
    <div class="memory-card-wrapper"
      :id="'memory-card-' + index"
      :style="{
        backgroundColor: memoryCardBackgroundColor,
        cursor: memoryCardCursor,
      }"
    > 
      <div class="profile-wrapper">
        <div class="profile-picture">
          <img src="images/papercrane.svg" height="50" width="50"/>
        </div>
        <div class="profile-name-wrapper">
          <div class="profile-job">{{memory.job ? memory.job : '　'}}</div>
          <div class="profile-name">{{memory.name}}</div>
        </div>
      </div>
      <div class="text-container">
        <div class="text-wrapper">
          {{memory.body}}
        </div>
        <div
          class="text-mask"
          :style="{
            backgroundImage: memoryCardMaskColor,
          }"
        ></div>
      </div>
      <div :class="{
        'full-button': true,
        'full-button-with-voice': memory.speach,
        }"
        :id="'full-button-' + index"
      >
        繼續閱讀
        <img v-show="memory.speach" class="full-button-voice-icon" src="images/turnon.svg" alt="turnon">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemoryCard',
  props: {
    memory: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cardColorSet: {
        1: '#ffffff',
        2: '#d5efed',
        3: '#fffef2',
      },
    };
  },
  computed: {
    memoryCardBackgroundColor() {
      return this.cardColorSet[this.memory.color];
    },
    memoryCardMaskColor() {
      return 'linear-gradient(' + this.cardColorSet[this.memory.color] + '00,' + this.cardColorSet[this.memory.color] + 'ff)';
    },
    memoryCardCursor() {
      if (window.innerWidth > 1023) {
        return 'pointer';
      } else return 'initial';
    },
  },
  methods: {
    showFullMemoryCard() {
      // call function of second layer of root
      this.$root.$children[0].$children[1].showFullMemoryCard(this.memory);
    },
    addShowFullEvent(item) {
      const vm = this;
      $(item + vm.index).click(function (event) {
        vm.showFullMemoryCard();
      });
    },
  },
  mounted() {
    // 解決infinite情況下，slick第一張和最後一張v-on無法綁定的問題
    // if (window.innerWidth > 1023) {
    //   this.addShowFullEvent('#memory-card-');
    // } else {
    //   this.addShowFullEvent('#full-button-');
    // }

    // 點擊繼續閱讀按鈕觸發「繼續閱讀」
      // this.addShowFullEvent('#full-button-');

    // 點擊整張卡片都可以觸發「繼續閱讀」
    this.addShowFullEvent('#memory-card-');
  },
};
</script>

<style lang="scss" scoped>
  .memory-card-container {
    padding: 2%;
    .memory-card-wrapper {
      position: relative;
      width: 100%;
      height: 550px;
      text-align: center;
      padding: 30px 20px;
      border: solid 1px #a0d7d3;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: .333s ease-in-out;
      @media only screen and (min-width: 320px) and (max-width: 374px) {
        height: 365px;
      }
      @media only screen and (min-width: 374px) and (max-width: 414px) {
        height: 375px;
      }
      .profile-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .profile-picture {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .profile-name-wrapper {
          text-align: left;
          overflow: hidden;
          .profile-name {
            line-height: 1.5;
            white-space: nowrap;
          }
          .profile-job {
            font-size: 12px;
            line-height: 1.5;
            color: #6f6f6f;
            white-space: nowrap;
          }
        }
      }
      .text-container {
        position: relative;
        width: 100%;
        height: 75%;
        overflow: hidden;
        .text-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          text-align: justify;
          white-space: pre-line;
          color: #000000;
        }
        .text-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .full-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 10%;
        color: #57b09f;
        cursor: pointer;
        .full-button-voice-icon {
          width: 1.5rem;
          margin: 0 5px;
        }
      }
      .full-button-with-voice {
        padding-left: calc(1.5rem + 5px);
      }
    }
  }
</style>

